// Core
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Custom layout
import MainLayout from "../../../Layouts/Main";

//styles
import "./styles.scss";

//assets
import assets from "../../../Assets";

import InputBox from "Components/InputBox";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DropDownBox from "Components/Common/DropDownBox";
import Button from "Components/Button";
import Modal from 'Components/Common/Modal';

//redux
import { useDispatch } from "react-redux";
import {
  deleteCompany,
  exportAllCompaniesList,
  fetchCompaniesList,
  fetchCompanyManagementCompany,
  fetchCompanyManagementIndustry,
  updateCompanyStatus,
} from "../../../Redux/Slices/companyManagementSlice";
import { notifySuccess } from "Services/Utils/toastNotification";

const CompanyManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [companyTableData, setCompanyTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);  
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  const [companyStatus, setCompanystatus] = useState(1);
  const [company, setCompany] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "Company Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "company_name",
        });
      },
    },
    {
      label: "Company Type",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "company_type_name",
        });
      },
    },
    {
      label: "Industry",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "industry_name",
        });
      },
    },
    {
      label: "No.of Users",
      sortKey: false,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "no_of_user",
        });
      },
    },
    {
  label: "Date Joined",
  sortKey: true,
  singleClickFunc: () => {
    setSortOptions({
      sort_by: !sortOptions.sort_by,
      order_by: "createdAt",
    });
  },
},
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "status" });
      },
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1)
  }, [search, company, industry])

  useEffect(() => {
    dispatch(
      fetchCompanyManagementCompany({
        callBack: companyListCB,
      })
    );
    dispatch(
      fetchCompanyManagementIndustry({
        callBack: industryListCB,
      })
    );
  }, [])

  useEffect(() => {
    setIsLoading(true)

    dispatch(
      fetchCompaniesList({
        data: {
          search: search,
          page: currentPage,
          limit: "10",
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
          companyId: company?.company_type_id || "",
          industryId: industry?.industry_type_id || "",
        },
        callBack: getCompaniesCB,
      })
    );
  }, [sortOptions, currentPage, companyStatus, search, company, industry]);

  const companyListCB = (value) => {
    // console.log(value)
    const updatedCategories = value.data.map((item) => ({
      ...item,
      label: item.company_type_name,
      value: item.company_type_id,
    }));
    const additionalObject = {
      label: "All Companies",
      value: "",
      company_name: "All Companies",
    };
    setCompanyList([additionalObject, ...updatedCategories]);
  };

  const industryListCB = (value) => {
    // console.log(value)
    const updatedCategories = value.data.map((item) => ({
      ...item,
      label: item.industry_name,
      value: item.industry_type_id,
    }));
    const additionalObject = {
      label: 'All Industries',
      value: '',
      industry_name: 'All Industries'
    };
    setIndustryList([additionalObject, ...updatedCategories])
  };

  const getCompaniesCB = (value) => {
    // console.log(value.data.data_list)
    setCompanyTableData(value?.data?.data_list || []);
    setTotalPage(value?.data?.pageMeta?.totalPages);
    setTotalCount(value?.data?.pageMeta?.total || 0);
    setTotalCount(value?.data?.pageMeta?.total || 0);
    setIsLoading(false)
    //add laabel and value for dropdown options
  };

  const handleOutsideClick = (e) => {
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null);
    }
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  const openDeleteConfirmationModal = (companyId) => {
    setCompanyToDelete(companyId);
    setIsModalOpen(true);
  };

  const confirmDeleteCompany = () => {
    if (companyToDelete) {
      dispatch(
        deleteCompany({
          data: {
            id: companyToDelete,
          },
          callBack: (value) => {
            console.log(value);
            notifySuccess("Company Deleted Successfully");
            setCompanystatus(!companyStatus);
            setOpenMenuId(null);
            setCompanyToDelete(null);
          },
        })
      );
      setIsModalOpen(false);
    }
  };

  const changeStatus = (status, id) => {
    let statusName = "active";
    if (status == 2) {
      statusName = "inactive";
    }
    dispatch(
      updateCompanyStatus({
        data: {
          status: statusName,
          id: id,
        },
        callBack: (value) => {
          //triggers rerender after status change
          setCompanystatus(!companyStatus);
          //closes the options menu
          setOpenMenuId(null);
        },
      })
    );
  };

  const handleExportAllCompany = () => {
    dispatch(
      exportAllCompaniesList({
        callBack: handleExports,
      })
    )
  }

  const handleExports = (data) => {
    const today = new Date();
    const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;

    const fileName = `Company_List_${formattedDate}.xlsx`;
    const url = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return (
    <MainLayout pageName={"Company Management"}>
      <div className="company-management-container">
        <div className="company-headerList">
          <div className="exportAllButton">
  <p className="totalCount">
    Total count : {totalCount}
  </p>

  <Button
    buttonStyle={{ height: "1vh",width:'177.5px' }}
    title="Export All"
    onClick={handleExportAllCompany}
  />
</div>
          <div className="company-management-header">
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={(e) => setSearch(e.target.value)}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "43px",
                width: "25vw",
                borderRadius: "0px",
                borderBottom: "1px solid #C1C7CD",
                boxShadow: "none",
                color: "black",
              }}
            />
            <div className="company-management-filter">
              <DropDownBox
                title="company"
                placeholder="Select Company Type"
                options={companyList}
                onChange={(option) => setCompany(option)}
                value={company}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    width: "220px",
                    fontFamily: "Roboto",
                    padding: "3px",
                    color: "#697077",
                    border: "none",
                    borderRadius: 0,
                    borderBottom: "1px solid #C1C7CD",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "#697077",
                  }),
                  option: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "#697077",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "black",
                  }),
                }}
              />
              <DropDownBox
                title="industry"
                placeholder="Select Industry"
                options={industryList}
                onChange={(option) => setIndustry(option)}
                value={industry}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    width: "200px",
                    fontFamily: "Roboto",
                    color: "#697077",
                    padding: "3px",
                    border: "none",
                    borderRadius: 0,
                    borderBottom: "1px solid #C1C7CD",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "#697077",
                  }),
                  option: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "#697077",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontFamily: "Roboto",
                    color: "black",
                  }),
                }}
              />
            </div>
            <div
              className="addNewCompanyButton"
              onClick={() => navigate("addCompany")}
            >
              <Button buttonStyle={{ height: "1vh" }} title="Add Company" />
            </div>
          </div>
        </div>

        <div className="company-management-table">
          <NormalTable headerDetails={headerDetails}>
            {companyTableData.length > 0
              ? companyTableData.map((company, index) => (
                <tr key={company.company_id} style={{ position: "relative" }}>
                  <td style={{ paddingLeft: "17px" }}>
                    {search ? index + 1 : (currentPage - 1) * 10 + (index + 1)}
                  </td>
                  <td>
                    {company.company_name.length > 25
                      ? `${company.company_name.substring(0, 25)}...`
                      : company.company_name}
                  </td>
                  <td>{company.company_type_name}</td>
                  <td>{company.industry_name}</td>
                  <td>{company.user_count}</td>
                  <td>
  {new Date(company.createdAt).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })}
</td>
                  <td
                    style={{
                      color: company.status === 2 ? "#10CA23" : "#FF482F",
                    }}
                  >
                    {company.status === 2 ? "Active" : "In Active"}
                  </td>
                  <td style={{ minWidth: "15px" }}>
                    <img
                      style={{ height: "15px", cursor: "pointer" }}
                      src={assets.Icons.optionsIcon}
                      alt="Options"
                      onClick={() => toggleMenu(company.company_id)}
                    />
                    {openMenuId === company.company_id && (
                      <div className="optionsCompanyMenu">
                        <ul>
                          <li
                            onClick={() =>
                              navigate(`viewCompany/${company.company_id}`)
                            }
                          >
                            <img src={assets.Icons.viewIcon} alt="" />
                            View
                          </li>
                          <li
                            onClick={() =>
                              navigate(`EditCompany/${company.company_id}`)
                            }
                          >
                            <img src={assets.Icons.editIcon} alt="" />
                            Edit
                          </li>
                          <li
                            onClick={() =>
                              openDeleteConfirmationModal(company.company_id)
                            }
                          >
                            <img src={assets.Icons.deleteIcon} alt="" />
                            Delete
                          </li>
                          <li
                            onClick={() =>
                              changeStatus(company.status, company.company_id)
                            }
                          >
                            <img
                              src={assets.Icons.activeInactiveIcon}
                              alt=""
                            />
                            Mark as{" "}
                            {company.status === 2 ? "Inactive" : "Active"}
                          </li>
                        </ul>
                      </div>
                    )}
                  </td>
                </tr>
              ))
              : " "}
          </NormalTable>
          <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
            <h3 style={{ textAlign: 'center', fontFamily: 'Roboto' }}>Are you sure you want to delete this company?</h3>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '20px' }}>
              <Button
                buttonStyle={{
                  width: "40%",
                  height: "2vh",
                }}
                title='Delete'
                onClick={confirmDeleteCompany}
              />
              <Button
                buttonStyle={{
                  height: "2vh",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid black",
                  width: "40%",
                }}
                titleStlye={{ color: "#888888" }}
                title="Cancel"
                onClick={() => setIsModalOpen(false)}
              />
            </div>
          </Modal>
        </div>
        {companyTableData.length > 0 ? (
          ""
        ) : (
          <p
            style={{
              textAlign: "center",
              fontFamily: "poppins",
              fontSize: "4vh",
            }}
          >
            {isLoading ? "Loading" : "No Data Found"}
          </p>
        )}
        {companyTableData.length > 0 ? (
          <div className="company-management-table-pagination">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPage}
              onPageChange={handlePageChange}
            />
          </div>
        ) : (
          " "
        )}
      </div>
    </MainLayout>
  );
};

export default CompanyManagement;
